import React from "react";
import {Container} from "react-bootstrap";
import {useTranslation} from "react-i18next";

const PrivacyPolicy = () => {
    const {t} = useTranslation();
    return (
        <Container className="my-5" dangerouslySetInnerHTML={{__html: t("pages.termsAndConditions")}}>

        </Container>
    );
};

export default PrivacyPolicy;
